import { render, staticRenderFns } from "./ProjectValuationScoreRiskTable.vue?vue&type=template&id=5f2e30e5&scoped=true&"
import script from "./ProjectValuationScoreRiskTable.vue?vue&type=script&lang=ts&"
export * from "./ProjectValuationScoreRiskTable.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectValuationScoreRiskTable.vue?vue&type=style&index=0&id=5f2e30e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2e30e5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTextField,VTooltip})
